<div class="under-construction-container">
  <svg
    width="667"
    height="667"
    viewBox="0 0 667 667"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_26394_3459)">
      <path d="M0 666.66H666.667V0.0054733H0V666.66Z" fill="#FBFCFF" />
      <path
        d="M220.461 463.23H222.273C224.18 463.23 225.883 461.824 225.883 459.434C225.883 457.199 224.18 455.652 222.273 455.652H217.867V467.434H220.461V463.23ZM221.852 457.699C222.602 457.699 223.398 458.355 223.398 459.434C223.398 460.559 222.602 461.184 221.852 461.184H220.461V457.699H221.852ZM232.352 462.934H229.367L230.852 458.73L232.352 462.934ZM236.758 467.434L231.961 455.652H229.773L224.992 467.434H227.773L228.617 465.059H233.117L233.961 467.434H236.758ZM242.945 457.902C244.086 457.902 245.258 458.371 245.836 459.621H248.695C247.883 457.168 245.539 455.48 242.945 455.48C239.617 455.48 236.867 458.215 236.867 461.543C236.867 464.871 239.617 467.605 242.945 467.605C246.305 467.605 248.992 464.887 248.992 461.543V461.137H243.18V463.105H246.18C245.539 464.887 244.086 465.246 242.945 465.246C241.07 465.246 239.508 463.574 239.508 461.574C239.508 459.59 241.07 457.902 242.945 457.902ZM257.457 465.074H253.238V462.699H257.285V460.34H253.238V458.012H257.457V455.652H250.645V467.434H257.457V465.074ZM270.762 455.652V462.465C270.762 464.09 270.277 465.012 268.496 465.012C266.715 465.012 266.215 464.09 266.215 462.465V455.652H263.621V462.84C263.621 465.98 265.418 467.605 268.496 467.605C271.559 467.605 273.355 465.98 273.355 462.84V455.652H270.762ZM284.438 467.434V455.652H281.828V462.996L277.781 455.652H275.188V467.434H277.781V460.09L281.828 467.434H284.438ZM289.086 465.043V458.059H289.867C291.867 458.059 293.227 459.59 293.227 461.543C293.227 463.496 291.852 465.043 289.867 465.043H289.086ZM286.523 455.652V467.434H290.023C293.367 467.434 295.867 464.871 295.867 461.543C295.867 458.215 293.336 455.652 290.023 455.652H286.523ZM304.344 465.074H300.125V462.699H304.172V460.34H300.125V458.012H304.344V455.652H297.531V467.434H304.344V465.074ZM309.035 463.23H309.051L311.863 467.434H315.145L311.77 463.105C313.254 462.73 314.457 461.418 314.457 459.434C314.457 457.199 312.754 455.652 310.848 455.652H306.441V467.434H309.035V463.23ZM310.426 457.699C311.176 457.699 311.973 458.355 311.973 459.434C311.973 460.559 311.176 461.184 310.426 461.184H309.035V457.699H310.426ZM328.824 463.434C328.34 464.465 327.168 465.184 325.949 465.184C324.043 465.184 322.512 463.559 322.512 461.543C322.512 459.543 324.043 457.902 325.949 457.902C327.137 457.902 328.324 458.559 328.809 459.621H331.699C330.902 457.215 328.637 455.48 325.949 455.48C322.605 455.48 319.887 458.199 319.887 461.543C319.887 464.887 322.605 467.605 325.949 467.605C328.637 467.605 330.918 465.855 331.715 463.434H328.824ZM342.297 461.527C342.297 463.34 340.641 465.012 338.828 465.012C337.016 465.012 335.359 463.34 335.359 461.527C335.359 459.699 337.016 458.059 338.828 458.059C340.641 458.059 342.297 459.699 342.297 461.527ZM344.891 461.543C344.891 458.277 342.078 455.48 338.828 455.48C335.563 455.48 332.766 458.277 332.766 461.543C332.766 464.793 335.563 467.605 338.828 467.605C342.078 467.605 344.891 464.793 344.891 461.543ZM355.801 467.434V455.652H353.191V462.996L349.145 455.652H346.551V467.434H349.145V460.09L353.191 467.434H355.801ZM362.449 465.59C361.168 465.59 360.059 464.949 359.996 463.559H357.355C357.371 466.434 359.746 467.715 362.355 467.715C364.762 467.715 367.23 466.684 367.23 463.918C367.23 459.434 360.434 460.934 360.434 458.84C360.434 457.949 361.449 457.605 362.184 457.605C363.48 457.605 364.184 458.012 364.324 459.23H366.84C366.746 456.559 364.574 455.48 362.137 455.48C359.996 455.48 357.746 456.621 357.746 459.043C357.746 463.402 364.559 461.918 364.559 464.215C364.559 465.262 363.262 465.59 362.449 465.59ZM373.805 458.012H377.164V455.652H367.852V458.012H371.211V467.434H373.805V458.012ZM380.898 463.23H380.914L383.727 467.434H387.008L383.633 463.105C385.117 462.73 386.32 461.418 386.32 459.434C386.32 457.199 384.617 455.652 382.711 455.652H378.305V467.434H380.898L380.898 463.23ZM382.289 457.699C383.039 457.699 383.836 458.355 383.836 459.434C383.836 460.559 383.039 461.184 382.289 461.184H380.898V457.699H382.289ZM394.73 455.652V462.465C394.73 464.09 394.246 465.012 392.465 465.012C390.684 465.012 390.184 464.09 390.184 462.465V455.652H387.59V462.84C387.59 465.98 389.387 467.605 392.465 467.605C395.527 467.605 397.324 465.98 397.324 462.84V455.652H394.73ZM407.656 463.434C407.172 464.465 406 465.184 404.781 465.184C402.875 465.184 401.344 463.559 401.344 461.543C401.344 459.543 402.875 457.902 404.781 457.902C405.969 457.902 407.156 458.559 407.641 459.621H410.531C409.734 457.215 407.469 455.48 404.781 455.48C401.438 455.48 398.719 458.199 398.719 461.543C398.719 464.887 401.438 467.605 404.781 467.605C407.469 467.605 409.75 465.855 410.547 463.434H407.656ZM417.035 458.012H420.395V455.652H411.082V458.012H414.441V467.434H417.035V458.012ZM424.125 467.434V455.652H421.531V467.434H424.125ZM435.309 461.527C435.309 463.34 433.652 465.012 431.84 465.012C430.027 465.012 428.371 463.34 428.371 461.527C428.371 459.699 430.027 458.059 431.84 458.059C433.652 458.059 435.309 459.699 435.309 461.527ZM437.902 461.543C437.902 458.277 435.09 455.48 431.84 455.48C428.574 455.48 425.777 458.277 425.777 461.543C425.777 464.793 428.574 467.605 431.84 467.605C435.09 467.605 437.902 464.793 437.902 461.543ZM448.809 467.434V455.652H446.199V462.996L442.152 455.652H439.559V467.434H442.152V460.09L446.199 467.434H448.809Z"
        fill="#496095"
      />
      <mask
        id="mask0_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask0_26394_3459)">
        <path
          d="M487.318 469.358H456.943C455.943 469.358 455.133 470.167 455.133 471.168C455.133 472.168 455.943 472.98 456.943 472.98H487.318C488.318 472.98 489.129 472.168 489.129 471.168C489.129 470.167 488.318 469.358 487.318 469.358Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask1_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask1_26394_3459)">
        <path
          d="M474.597 443.534C474.456 443.143 474.084 442.885 473.668 442.885H470.186C469.766 442.885 469.393 443.15 469.254 443.547L459.453 471.586H484.81L474.597 443.534Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask2_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask2_26394_3459)">
        <path
          d="M467.439 448.739L465.891 453.168H478.103L476.491 448.739H467.439Z"
          fill="#EBEFF2"
        />
      </g>
      <mask
        id="mask3_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask3_26394_3459)">
        <path
          d="M463.493 460.024L461.945 464.453H482.212L480.599 460.024H463.493Z"
          fill="#EBEFF2"
        />
      </g>
      <mask
        id="mask4_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask4_26394_3459)">
        <path
          d="M209.724 469.358H179.351C178.35 469.358 177.539 470.167 177.539 471.168C177.539 472.168 178.35 472.98 179.351 472.98H209.724C210.724 472.98 211.535 472.168 211.535 471.168C211.535 470.167 210.724 469.358 209.724 469.358Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask5_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask5_26394_3459)">
        <path
          d="M196.996 443.534C196.853 443.143 196.482 442.885 196.066 442.885H192.585C192.165 442.885 191.79 443.15 191.652 443.547L181.852 471.586H207.209L196.996 443.534Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask6_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask6_26394_3459)">
        <path
          d="M189.845 448.739L188.297 453.168H200.509L198.897 448.739H189.845Z"
          fill="#EBEFF2"
        />
      </g>
      <mask
        id="mask7_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask7_26394_3459)">
        <path
          d="M185.9 460.024L184.352 464.453H204.617L203.005 460.024H185.9Z"
          fill="#EBEFF2"
        />
      </g>
      <mask
        id="mask8_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="667"
        height="668"
      >
        <path d="M0 -0.00256443H666.667V666.664H0V-0.00256443Z" fill="white" />
      </mask>
      <g mask="url(#mask8_26394_3459)">
        <g opacity="0.5">
          <mask
            id="mask9_26394_3459"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="138"
            y="173"
            width="179"
            height="221"
          >
            <path
              d="M138.539 173.525H316.82V393.785H138.539V173.525Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask9_26394_3459)">
            <path
              d="M211.336 267.473H138.539V393.785H211.336H231.238H316.82V173.525H211.336V267.473Z"
              fill="#D0E1FF"
            />
          </g>
        </g>
      </g>
      <mask
        id="mask10_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="667"
        height="668"
      >
        <path d="M0 -0.00256443H666.667V666.664H0V-0.00256443Z" fill="white" />
      </mask>
      <g mask="url(#mask10_26394_3459)">
        <g opacity="0.5">
          <mask
            id="mask11_26394_3459"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="331"
            y="94"
            width="184"
            height="300"
          >
            <path
              d="M331.336 94.2332H514.263V393.785H331.336V94.2332Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask11_26394_3459)">
            <path
              d="M436.82 275.124V94.2331H331.336V393.785H432.667H436.82H514.263V275.124H436.82Z"
              fill="#D0E1FF"
            />
          </g>
        </g>
      </g>
      <mask
        id="mask12_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask12_26394_3459)">
        <path d="M622.668 392.453H44V389.786H622.668V392.453Z" fill="#496095" />
      </g>
      <mask
        id="mask13_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask13_26394_3459)">
        <path
          d="M425.086 404.309H170.789V204.453H425.086V404.309Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask14_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask14_26394_3459)">
        <path
          d="M425.086 404.309H170.789V227.091H425.086V404.309Z"
          fill="white"
        />
      </g>
      <mask
        id="mask15_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask15_26394_3459)">
        <path
          d="M183.608 215.336C183.608 217.386 181.946 219.047 179.897 219.047C177.848 219.047 176.188 217.386 176.188 215.336C176.188 213.287 177.848 211.626 179.897 211.626C181.946 211.626 183.608 213.287 183.608 215.336Z"
          fill="white"
        />
      </g>
      <mask
        id="mask16_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask16_26394_3459)">
        <path
          d="M199.381 215.336C199.381 217.386 197.72 219.047 195.67 219.047C193.622 219.047 191.961 217.386 191.961 215.336C191.961 213.287 193.622 211.626 195.67 211.626C197.72 211.626 199.381 213.287 199.381 215.336Z"
          fill="white"
        />
      </g>
      <mask
        id="mask17_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask17_26394_3459)">
        <path
          d="M215.162 215.336C215.162 217.386 213.501 219.047 211.453 219.047C209.404 219.047 207.742 217.386 207.742 215.336C207.742 213.287 209.404 211.626 211.453 211.626C213.501 211.626 215.162 213.287 215.162 215.336Z"
          fill="white"
        />
      </g>
      <mask
        id="mask18_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask18_26394_3459)">
        <path
          d="M337.6 222.012H232.936C229.438 222.012 226.602 219.176 226.602 215.677C226.602 212.178 229.438 209.341 232.936 209.341H337.6C341.099 209.341 343.935 212.178 343.935 215.677C343.935 219.176 341.099 222.012 337.6 222.012Z"
          fill="white"
        />
      </g>
      <mask
        id="mask19_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask19_26394_3459)">
        <path
          d="M409.59 222.012H360.038C356.539 222.012 353.703 219.176 353.703 215.677C353.703 212.178 356.539 209.341 360.038 209.341H409.59C413.088 209.341 415.924 212.178 415.924 215.677C415.924 219.176 413.088 222.012 409.59 222.012Z"
          fill="white"
        />
      </g>
      <mask
        id="mask20_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask20_26394_3459)">
        <path
          d="M281.546 357.109H191.086V306.051H281.546V357.109Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask21_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask21_26394_3459)">
        <path
          d="M281.546 294.441H191.086V243.383H281.546V294.441Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask22_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask22_26394_3459)">
        <path
          d="M280.763 374.008H191.875V370.008H280.763V374.008Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask23_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask23_26394_3459)">
        <path
          d="M280.763 387.34H191.875V383.34H280.763V387.34Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask24_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask24_26394_3459)">
        <path
          d="M401.708 374.008H312.82V370.008H401.708V374.008Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask25_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask25_26394_3459)">
        <path
          d="M401.708 387.34H312.82V383.34H401.708V387.34Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask26_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask26_26394_3459)">
        <path
          d="M172.12 402.974H423.75V205.785H172.12V402.974ZM426.417 405.641H169.453V203.118H426.417V405.641Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask27_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask27_26394_3459)">
        <path
          d="M463.924 372.896H484.679V158.675H463.924V372.896ZM487.346 375.562H461.258V156.008H487.346V375.562Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask28_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask28_26394_3459)">
        <path
          d="M490.918 386.676H457.688V362.864H490.918V386.676Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask29_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask29_26394_3459)">
        <path
          d="M486.148 350.23H463.037C462.508 350.23 462.028 349.917 461.814 349.43C461.602 348.945 461.698 348.38 462.058 347.99L484.281 323.992L486.237 325.804L466.089 347.564H486.148V350.23Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask30_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask30_26394_3459)">
        <path
          d="M486.148 326.184H463.037C462.508 326.184 462.028 325.87 461.814 325.384C461.602 324.898 461.698 324.333 462.058 323.945L484.281 299.945L486.237 301.756L466.089 323.517H486.148V326.184Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask31_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask31_26394_3459)">
        <path
          d="M486.148 302.141H463.037C462.508 302.141 462.028 301.827 461.814 301.341C461.602 300.855 461.698 300.29 462.058 299.902L484.281 275.902L486.237 277.713L466.089 299.474H486.148V302.141Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask32_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask32_26394_3459)">
        <path
          d="M486.148 278.094H463.037C462.508 278.094 462.028 277.78 461.814 277.294C461.602 276.808 461.698 276.243 462.058 275.855L484.281 251.855L486.237 253.666L466.089 275.427H486.148V278.094Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask33_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask33_26394_3459)">
        <path
          d="M486.148 254.047H463.037C462.508 254.047 462.028 253.734 461.814 253.247C461.602 252.762 461.698 252.196 462.058 251.808L484.281 227.808L486.237 229.619L466.089 251.38H486.148V254.047Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask34_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask34_26394_3459)">
        <path
          d="M486.148 230.004H463.037C462.508 230.004 462.028 229.691 461.814 229.204C461.602 228.719 461.698 228.153 462.058 227.765L484.281 203.765L486.237 205.576L466.089 227.337H486.148V230.004Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask35_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask35_26394_3459)">
        <path
          d="M486.148 205.957H463.037C462.508 205.957 462.028 205.644 461.814 205.157C461.602 204.672 461.698 204.106 462.058 203.718L484.281 179.718L486.237 181.529L466.089 203.29H486.148V205.957Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask36_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask36_26394_3459)">
        <path
          d="M486.148 181.914H463.037C462.508 181.914 462.028 181.601 461.814 181.114C461.602 180.629 461.698 180.063 462.058 179.675L484.281 155.675L486.237 157.486L466.089 179.247H486.148V181.914Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask37_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask37_26394_3459)">
        <path
          d="M487.3 182.391H445.008V146.737H487.3V182.391Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask38_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask38_26394_3459)">
        <path
          d="M550.855 167.215H508.562V146.736H550.855V167.215Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask39_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask39_26394_3459)">
        <path
          d="M550.152 149.34H341.263C340.527 149.34 339.93 148.743 339.93 148.007C339.93 147.271 340.527 146.673 341.263 146.673H550.152C550.888 146.673 551.486 147.271 551.486 148.007C551.486 148.743 550.888 149.34 550.152 149.34Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask40_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask40_26394_3459)">
        <path
          d="M352.302 240.898H350.969V154.232H352.302V240.898Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask41_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask41_26394_3459)">
        <path
          d="M502.25 392.895H446.352V382.417H502.25V392.895Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask42_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask42_26394_3459)">
        <path
          d="M466.31 148.992C466.14 148.992 465.969 148.927 465.838 148.798L454.701 137.659H352.586L342.116 148.131C341.854 148.391 341.433 148.391 341.172 148.131C340.912 147.87 340.912 147.448 341.172 147.187L352.034 136.326H455.253L466.782 147.854C467.042 148.115 467.042 148.536 466.782 148.798C466.652 148.927 466.481 148.992 466.31 148.992Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask43_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask43_26394_3459)">
        <path
          d="M551.043 148.992C550.803 148.992 550.571 148.862 550.453 148.635L539.306 127.342H512.274L501.793 147.962C501.626 148.288 501.223 148.418 500.897 148.254C500.569 148.087 500.437 147.686 500.603 147.356L511.457 126.008H540.113L551.633 148.016C551.805 148.343 551.678 148.746 551.351 148.916C551.253 148.968 551.147 148.992 551.043 148.992Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask44_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask44_26394_3459)">
        <path
          d="M356.52 154.232C356.52 156.932 354.33 159.121 351.63 159.121C348.932 159.121 346.742 156.932 346.742 154.232C346.742 151.532 348.932 149.342 351.63 149.342C354.33 149.342 356.52 151.532 356.52 154.232Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask45_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask45_26394_3459)">
        <path
          d="M409.106 296.67L297.466 306.988L292.148 249.455L403.788 239.138L409.106 296.67Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask46_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask46_26394_3459)">
        <path
          d="M380.542 137.648C380.256 137.648 379.991 137.463 379.904 137.176C379.796 136.824 379.995 136.451 380.347 136.344L479.058 106.246C479.208 106.202 479.37 106.208 479.512 106.27L526.296 126.015C526.636 126.158 526.795 126.548 526.652 126.888C526.508 127.228 526.118 127.387 525.779 127.243L479.216 107.592L380.736 137.619C380.671 137.639 380.606 137.648 380.542 137.648Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask47_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask47_26394_3459)">
        <path
          d="M463.717 149.082C463.559 149.082 463.399 149.054 463.243 148.994C462.554 148.733 462.209 147.963 462.47 147.274L478.014 106.375C478.223 105.821 478.771 105.471 479.369 105.521C479.961 105.569 480.45 106.003 480.567 106.586L488.602 146.474C488.747 147.195 488.279 147.899 487.558 148.045C486.838 148.186 486.133 147.722 485.987 147.001L478.865 111.641L464.963 148.222C464.761 148.754 464.254 149.082 463.717 149.082Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask48_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask48_26394_3459)">
        <path
          d="M481.951 106.848C481.951 108.332 480.749 109.535 479.265 109.535C477.781 109.535 476.578 108.332 476.578 106.848C476.578 105.364 477.781 104.162 479.265 104.162C480.749 104.162 481.951 105.364 481.951 106.848Z"
          fill="#B7CDFF"
        />
      </g>
      <mask
        id="mask49_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask49_26394_3459)">
        <path
          d="M366.485 149.117C366.338 149.117 366.19 149.069 366.066 148.969L352.974 138.387V148.281C352.974 148.649 352.675 148.948 352.307 148.948C351.938 148.948 351.641 148.649 351.641 148.281V136.991C351.641 136.733 351.789 136.5 352.019 136.389C352.25 136.277 352.526 136.309 352.726 136.472L366.905 147.932C367.191 148.164 367.235 148.584 367.003 148.869C366.873 149.033 366.679 149.117 366.485 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask50_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask50_26394_3459)">
        <path
          d="M379.142 149.117C378.996 149.117 378.848 149.069 378.724 148.969L365.63 138.387V148.281C365.63 148.649 365.333 148.948 364.964 148.948C364.596 148.948 364.297 148.649 364.297 148.281V136.991C364.297 136.733 364.445 136.5 364.677 136.389C364.906 136.277 365.182 136.309 365.384 136.472L379.562 147.932C379.849 148.164 379.893 148.584 379.661 148.869C379.53 149.033 379.337 149.117 379.142 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask51_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask51_26394_3459)">
        <path
          d="M391.806 149.117C391.66 149.117 391.512 149.069 391.388 148.969L378.294 138.387V148.281C378.294 148.649 377.997 148.948 377.628 148.948C377.26 148.948 376.961 148.649 376.961 148.281V136.991C376.961 136.733 377.109 136.5 377.341 136.389C377.57 136.277 377.846 136.309 378.048 136.472L392.226 147.932C392.513 148.164 392.557 148.584 392.325 148.869C392.194 149.033 392.001 149.117 391.806 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask52_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask52_26394_3459)">
        <path
          d="M404.469 149.117C404.322 149.117 404.174 149.069 404.05 148.969L390.958 138.387V148.281C390.958 148.649 390.66 148.948 390.292 148.948C389.922 148.948 389.625 148.649 389.625 148.281V136.991C389.625 136.733 389.773 136.5 390.004 136.389C390.234 136.277 390.509 136.309 390.71 136.472L404.889 147.932C405.176 148.164 405.22 148.584 404.988 148.869C404.857 149.033 404.664 149.117 404.469 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask53_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask53_26394_3459)">
        <path
          d="M417.127 149.117C416.98 149.117 416.832 149.069 416.708 148.969L403.615 138.387V148.281C403.615 148.649 403.317 148.948 402.948 148.948C402.58 148.948 402.281 148.649 402.281 148.281V136.991C402.281 136.733 402.429 136.5 402.661 136.389C402.892 136.277 403.167 136.309 403.368 136.472L417.547 147.932C417.833 148.164 417.877 148.584 417.645 148.869C417.515 149.033 417.321 149.117 417.127 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask54_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask54_26394_3459)">
        <path
          d="M429.791 149.117C429.644 149.117 429.496 149.069 429.372 148.969L416.279 138.387V148.281C416.279 148.649 415.981 148.948 415.612 148.948C415.244 148.948 414.945 148.649 414.945 148.281V136.991C414.945 136.733 415.093 136.5 415.325 136.389C415.555 136.277 415.831 136.309 416.032 136.472L430.211 147.932C430.497 148.164 430.541 148.584 430.309 148.869C430.179 149.033 429.985 149.117 429.791 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask55_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask55_26394_3459)">
        <path
          d="M442.447 149.117C442.3 149.117 442.152 149.069 442.028 148.969L428.935 138.387V148.281C428.935 148.649 428.638 148.948 428.268 148.948C427.9 148.948 427.602 148.649 427.602 148.281V136.991C427.602 136.733 427.75 136.5 427.982 136.389C428.211 136.277 428.487 136.309 428.688 136.472L442.867 147.932C443.154 148.164 443.198 148.584 442.966 148.869C442.835 149.033 442.642 149.117 442.447 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask56_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask56_26394_3459)">
        <path
          d="M455.111 149.117C454.964 149.117 454.816 149.069 454.692 148.969L441.599 138.387V148.281C441.599 148.649 441.302 148.948 440.932 148.948C440.564 148.948 440.266 148.649 440.266 148.281V136.991C440.266 136.733 440.414 136.5 440.646 136.389C440.876 136.277 441.152 136.309 441.352 136.472L455.531 147.932C455.818 148.164 455.862 148.584 455.63 148.869C455.499 149.033 455.306 149.117 455.111 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask57_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask57_26394_3459)">
        <path
          d="M529.956 149.117C529.767 149.117 529.579 149.037 529.447 148.881L512.443 128.813V148.281C512.443 148.649 512.144 148.948 511.776 148.948C511.407 148.948 511.109 148.649 511.109 148.281V126.996C511.109 126.716 511.284 126.465 511.545 126.369C511.809 126.272 512.103 126.351 512.284 126.564L530.464 148.02C530.703 148.3 530.667 148.721 530.387 148.959C530.261 149.065 530.108 149.117 529.956 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask58_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask58_26394_3459)">
        <path
          d="M543.034 149.117C542.818 149.117 542.606 149.012 542.478 148.819L529.521 129.213V148.281C529.521 148.649 529.223 148.948 528.854 148.948C528.486 148.948 528.188 148.649 528.188 148.281V126.996C528.188 126.701 528.381 126.441 528.662 126.357C528.947 126.275 529.249 126.383 529.41 126.628L543.59 148.083C543.793 148.391 543.707 148.804 543.401 149.007C543.287 149.081 543.161 149.117 543.034 149.117Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask59_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask59_26394_3459)">
        <path
          d="M355.834 242.674C355.834 244.992 353.954 246.871 351.636 246.871C349.318 246.871 347.438 244.992 347.438 242.674C347.438 240.355 349.318 238.476 351.636 238.476C353.954 238.476 355.834 240.355 355.834 242.674Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask60_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask60_26394_3459)">
        <path
          d="M126.823 390.453H124.156V326.453H126.823V390.453Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask61_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask61_26394_3459)">
        <path
          d="M76.151 390.453H73.4844V326.453H76.151V390.453Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask62_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask62_26394_3459)">
        <path
          d="M133.779 357.117H66.8203V332.451H133.779V357.117Z"
          fill="#E1ECFF"
        />
      </g>
      <mask
        id="mask63_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask63_26394_3459)">
        <path
          d="M133.779 357.117V333.784L121.469 357.117H133.779Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask64_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask64_26394_3459)">
        <path
          d="M91.4688 357.117H105.79L118.805 332.451H104.483L91.4688 357.117Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask65_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask65_26394_3459)">
        <path
          d="M74.4816 332.451L66.8203 346.972V357.117H75.7883L88.803 332.451H74.4816Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask66_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask66_26394_3459)">
        <path
          d="M136.818 374.453H63.4844V371.786H136.818V374.453Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask67_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask67_26394_3459)">
        <path
          d="M590.815 390.453H588.148V326.453H590.815V390.453Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask68_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask68_26394_3459)">
        <path
          d="M540.151 390.453H537.484V326.453H540.151V390.453Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask69_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask69_26394_3459)">
        <path
          d="M597.779 357.117H530.82V332.451H597.779V357.117Z"
          fill="#E1ECFF"
        />
      </g>
      <mask
        id="mask70_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask70_26394_3459)">
        <path
          d="M597.779 357.117V333.784L585.469 357.117H597.779Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask71_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask71_26394_3459)">
        <path
          d="M555.469 357.117H569.79L582.805 332.451H568.483L555.469 357.117Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask72_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask72_26394_3459)">
        <path
          d="M538.482 332.451L530.82 346.972V357.117H539.788L552.803 332.451H538.482Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask73_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask73_26394_3459)">
        <path
          d="M600.818 374.453H527.484V371.786H600.818V374.453Z"
          fill="#496095"
        />
      </g>
      <mask
        id="mask74_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask74_26394_3459)">
        <path
          d="M165.998 408.889H135.624C134.623 408.889 133.812 409.7 133.812 410.7C133.812 411.7 134.623 412.512 135.624 412.512H165.998C166.998 412.512 167.808 411.7 167.808 410.7C167.808 409.7 166.998 408.889 165.998 408.889Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask75_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask75_26394_3459)">
        <path
          d="M153.277 383.065C153.135 382.676 152.763 382.416 152.347 382.416H148.866C148.446 382.416 148.071 382.681 147.933 383.079L138.133 411.117H163.49L153.277 383.065Z"
          fill="#FF7540"
        />
      </g>
      <mask
        id="mask76_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask76_26394_3459)">
        <path
          d="M146.118 388.27L144.57 392.699H156.782L155.17 388.27H146.118Z"
          fill="#EBEFF2"
        />
      </g>
      <mask
        id="mask77_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="667"
        height="667"
      >
        <path d="M0 0.00134182H666.667V666.668H0V0.00134182Z" fill="white" />
      </mask>
      <g mask="url(#mask77_26394_3459)">
        <path
          d="M142.173 399.556L140.625 403.984H160.892L159.278 399.556H142.173Z"
          fill="#EBEFF2"
        />
      </g>
      <mask
        id="mask78_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="667"
        height="668"
      >
        <path d="M0 -0.00256443H666.667V666.664H0V-0.00256443Z" fill="white" />
      </mask>
      <g mask="url(#mask78_26394_3459)">
        <g opacity="0.5">
          <mask
            id="mask79_26394_3459"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="111"
            y="156"
            width="61"
            height="28"
          >
            <path
              d="M111.75 156.451H171.826V183.195H111.75V156.451Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask79_26394_3459)">
            <path
              d="M161.457 172.826C159.233 172.826 157.177 173.533 155.487 174.725V171.786C155.487 163.318 148.623 156.453 140.154 156.453C131.686 156.453 124.821 163.318 124.821 171.786V177.579C123.433 176.263 121.562 175.45 119.497 175.45C115.218 175.45 111.75 178.918 111.75 183.195H171.826C171.826 177.469 167.183 172.826 161.457 172.826Z"
              fill="#D0E1FF"
            />
          </g>
        </g>
      </g>
      <mask
        id="mask80_26394_3459"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="667"
        height="668"
      >
        <path d="M0 -0.00256443H666.667V666.664H0V-0.00256443Z" fill="white" />
      </mask>
      <g mask="url(#mask80_26394_3459)">
        <g opacity="0.5">
          <mask
            id="mask81_26394_3459"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="249"
            y="119"
            width="44"
            height="20"
          >
            <path
              d="M249.086 119.119H292.823V138.59H249.086V119.119Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask81_26394_3459)">
            <path
              d="M285.274 131.041C283.655 131.041 282.158 131.555 280.929 132.423V130.283C280.929 124.118 275.93 119.121 269.765 119.121C263.601 119.121 258.602 124.118 258.602 130.283V134.502C257.591 133.542 256.229 132.951 254.725 132.951C251.61 132.951 249.086 135.475 249.086 138.59H292.823C292.823 134.421 289.443 131.041 285.274 131.041Z"
              fill="#D0E1FF"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_26394_3459">
        <rect width="666.667" height="666.667" fill="white" />
      </clipPath>
    </defs>
  </svg>
</div>
